import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import './index.css';
import { LanguageProvider } from './utils/LanguageContext';
import ShopPage from "./pages/ShopPage";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import ContactPage from "./pages/ContactPage";
import BlogPage from "./pages/BlogPage";
import Header from "./components/Header";
import Footer from "./components/Footer";
import SingleNewsPage from "./pages/singleNews";
import FAQPage from "./pages/Faqs";
import {HelmetProvider} from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
        <HelmetProvider>
            <BrowserRouter>
                <LanguageProvider>
                    <Header/>
                        <Routes>
                    {/* Home Page */}
                    <Route path="/" element={<HomePage />} />

                    {/* Shop Page */}
                    <Route path="/shop" element={<ShopPage />} />

                    {/* Product Detail Page */}
                    <Route path="/product/:id" element={<ProductDetailPage />} />

                    {/* About Page */}
                    <Route path="/about" element={<AboutPage />} />

                    {/* Services Page */}
                    <Route path="/faqs" element={<FAQPage />} />

                    {/* Contact Page */}
                    <Route path="/contact" element={<ContactPage />} />

                    {/* Blog Page */}
                    <Route path="/blog" element={<BlogPage />} />

                    {/* Blog Post Detail (Optional) */}
                    <Route path="/blog/:id" element={<SingleNewsPage />} />

                    <Route path="*" element={<HomePage />} />
                </Routes>
                    <Footer/>
                </LanguageProvider>
            </BrowserRouter>
        </HelmetProvider>
);